import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { VisThresholdsColors } from '../utils/UNSAFE_meterUtils';
import type { Ref } from 'preact/hooks';

export type RatingStarColorType = 'neutral' | 'gold' | ColorProps['color'] | VisThresholdsColors;

export function getValue(
  pageX: number,
  max: number,
  step: number,
  dimensionsRef: Ref<{ width: number; x: number }>,
  isRtl: boolean
): number {
  const dimensions = dimensionsRef.current;
  if (!dimensions || dimensions.width === 0) {
    return -1;
  }
  const width = pageX - dimensions.x;
  const val = (max * (isRtl ? dimensions.width - width : width)) / dimensions.width;
  const numSteps = val / step;

  return numSteps < 0.5 ? 0 : Math.min(max, Math.ceil(numSteps) * step);
}

export function getDimensions(element: HTMLElement | null) {
  if (!element) {
    return {
      width: 0,
      x: 0
    };
  }

  const rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    x: rect.x + window.scrollX
  };
}

/**
 * Returns The color in rating gauge, if the color enum is supported. undefined otherwise.
 * @param color The color in rating gauge.
 * @returns The color in rating gauge, if the color enum is supported. undefined otherwise.
 */
export function getColorEnum(color: string | undefined) {
  return color === 'neutral' ||
    color === 'gold' ||
    color === 'danger' ||
    color === 'warning' ||
    color === 'success'
    ? color
    : undefined;
}
